import { render, staticRenderFns } from "./ListWines.vue?vue&type=template&id=03987140&"
import script from "./ListWines.vue?vue&type=script&lang=js&"
export * from "./ListWines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports